/**
 * Phase 23 — Billing API client. Thin wrappers around /api/billing/*.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function _authHeader() {
  const tok = localStorage.getItem('clasifi_token');
  return tok ? { Authorization: `Bearer ${tok}` } : {};
}

async function _req(path, init = {}) {
  const res = await fetch(`${BACKEND_URL}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ..._authHeader(), ...(init.headers ?? {}) },
  });
  const raw = await res.text();
  if (!res.ok) {
    if (res.status === 401 && !path.startsWith('/api/auth/login')) {
      try { window.dispatchEvent(new Event('clasifi:401')); } catch {}
    }
    let detail = raw;
    try { detail = JSON.parse(raw).detail ?? raw; } catch {}
    throw { status: res.status, detail };
  }
  return raw ? JSON.parse(raw) : undefined;
}

export const getPlans = () => _req('/api/billing/plans');
export const getSubscription = () => _req('/api/billing/subscription');
export const createCheckout = (planCode) =>
  _req('/api/billing/checkout', { method: 'POST', body: JSON.stringify({ plan_code: planCode }) });
export const changePlan = (planCode) =>
  _req('/api/billing/change-plan', { method: 'POST', body: JSON.stringify({ plan_code: planCode }) });
export const getHistory = () => _req('/api/billing/history');
export const settleCheckoutSession = (sessionId) =>
  _req(`/api/billing/debug/session?session_id=${encodeURIComponent(sessionId)}`);
